import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";


const getPermissions: EvokeAction<AppState, AppActions> = async store => {
    try {
      const permissions = await api.get("permissions");
      console.log("permissions",permissions)
      await store.update(state => {     
        state.permissions = permissions;       
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const addPermission: EvokeAction<AppState, AppActions> = async (
  store,
  values:object,
  roleId:number
) => {
  try {
    
    console.log("values",values,roleId)
     const createdPermission = await api.post(
      `roles/${roleId}/permissions`,
        {},
      values
    );
   console.log("createdPermission",createdPermission)
   
    // if (!createdPermission.error && createdPermission.length!==0) {
    //    await store.update(state => {
      
    //      if (state.permissions !== undefined) {
           
    //        createdPermission.map((i:any)=>{
    //         state.permissions.push(i);
            
    //        });
           
    //      }
    //    });

    // }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};



const editPermission: EvokeAction<AppState, AppActions> = async (
  store,
  values:object,
  roleId:number
) => {
  try {
    
     const editedPermission = await api.patch(
      `roles/${roleId}/permissions`,
        {},
      values
    );
   console.log("editedPermission",editedPermission)
    // if (!editedPermission.error && editedPermission.length!==0) {
    //   await store.update(state => {
    //     if (state.permissions !== undefined) {
           
    //       editedPermission.map((i:any)=>{
    //        state.permissions.push(i);
           
    //       });
          
    //     }
    //   });
    // }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};


export const permissionActions = {
  getPermissions,
  addPermission,
  editPermission
};
